import React from 'react';
import Flex from '@wix/da-ds/pkg/Flex';
import TierPricePerMonth from '../TierPricePerMonth';
import s from './TierPriceWithBadge.scss';
const TierPriceWithBadge = ({ price, showPlaceholder, className })=>{
    return /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center",
        className: className
    }, showPlaceholder && !price ? /*#__PURE__*/ React.createElement("span", {
        className: s['placeholder']
    }) : /*#__PURE__*/ React.createElement(TierPricePerMonth, {
        price: price
    }));
};
TierPriceWithBadge.displayName = 'TierPriceWithBadge';
export default TierPriceWithBadge;
